<template>
  <div class="card-item">
    <div
      :style="styles"
      :class="['service_main', isAdvanced ? 'service_advanced' : '']"
    >
      <h3
        class="service_title"
        v-text="title"
      />
      <div class="service_price">
        <slot name="price" />
        <span class="price_unit">{{ $t('message["1524"]') }}</span>
        <slot name="header" />
      </div>
      <slot name="list" />
    </div>
  </div>
</template>

<script>
// const serviceLevel = '高级' // this.$t('message["1184"]')
import i18n from '@/lib/language'
// i18n.t('message["3"]')
export default {
  props: {
    styles: {
      type: String,
      default: 'height: 595px;'
    },
    // 是否为高级版
    isAdvanced: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: i18n.t('message["1184"]')
    }
  },
  data () {
    return {
    }
  },
  computed: {
    serviceLevel () {
      return this.$t('message["1184"]')
    }
  }
}
</script>

<style scoped lang="scss">
.service_main {
  position: relative;
  display: inline-block;
  width: 320px;
  background-image: linear-gradient(274deg, #f2f2f2, #fbfbfb);
  border-radius: 4px;
  overflow: hidden;
  margin-top: 16px;
  margin-left: 70px;
  .service_title {
    font-size: 24px;
    line-height: 32px;
    color:#333;
    font-family:PingFangSC-Semibold;
    font-weight:600;
    text-align: center;
    margin-top: 40px;
  }
  .service_price {
    text-align: center;
    color: #333;
    margin-top: 22px;
    .price {
      font-family:Roboto-Bold;
      font-size: 64px;
      font-weight: bold;
      b {
        font-size: 24px;
        margin-left: 8px
      }
    }
    .price_unit {
      font-size: 14px;
      font-weight: bold;
    }
    .service_unit_price {
      font-size:14px;
      font-family:PingFangSC-Semibold;
      color:#fff;
      margin-top: 16px;
      opacity: .6;
    }
  }
  .service_list {
    position: absolute;
    width: 100%;
    top: 261px;
    left: 40px;
    // margin: 80px 0 0 40px;
    li:not(:first-child) {
      margin-top: 6px;
    }
    li {
      svg {
        vertical-align: middle;
      }
      span {
        color: #666;
        margin-left: 8px;
        vertical-align: middle
      }
    }
  }
  .s-i-btn {
    display: inline-block;
    width: 200px;
    height: 40px;
    position: absolute;
    left: 50%;
    bottom: 40px;
    transform: translateX(-50%);
    background: #e5e5e5;
    color: #666;
    line-height: 40px;
    font-size: 16px;
    border-radius: 4px;
    text-align: center;
    margin-top: 35px;
  }
}
.service_advanced {
  background:linear-gradient(180deg,rgba(101,143,197,1) 0%,rgba(38,70,102,1) 100%);
  margin-left: 40px;
  .service_title, .service_price, .price, .price b, .service_list span {
    color: #fff !important
  }
  .s-i-advanced-btn {
    background: #fff;
    color: #5077AA
  }
}
</style>
